import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionEquipment, logisticsAsset, retailExhibition } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import video from '@src/assets/images/solution/logisticsAsset/video/rtlsVideo.mp4';

export default {
  desc: 'Hệ thống định vị trong nhà GPS trong nhà là hệ thống đo lường vị trí của các đối tượng di chuyển trong không gian nội thất.',
  keywords: 'IndoorGPS,Hệ thống định vị trong nhà,Hethong dinh vi trong nha,RTLS,UWB,Theo dõi vị trí,Theo doi vi tri',
  ogSite: 'Giải pháp, ứng dụng GPS trong nhà',
  title: 'Giải pháp, ứng dụng GPS trong nhà',
  ogUrl: 'https://orbro.io/vi/blog/indoor-gps',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDldPhj_PKmAYMbJqfxzx90kvwqvmaEJvuGa-Tilhn_LDEQtT2ogbSz96n2WA7ZAkr8WCRqOH4FmFoBufrCikZrXDwtb5It8GdPL_VxgMjGS1EnQAjJ4qrWYj4KcPq2uUwiEvls5sC1jYuNZWL9bM_ehwpvaclUZmuxqNlqIHYdw-FwmLbIsnVL148GQBP4aPXNwhvDLGmbonOGByrjok58YvYwxO339qVTHGs3T_pNB3bpk3KtiI87LFAQTozPEkOlHvJdDGXaK_LwvsTpFUd_Y38nRFI6ff6khHkuBibyrmO3mFIAaSxXYgd--mNSgro0BX8zdHQ8oeun8sW6yug8ZCW_V0fedhTrafZhPhB6nDSrdpkoQs10G4ftI0mB_kPLYFSeyTOOORJzy5jXFMNQmlE9TwHl3RNxv32lu3iDvi1odQiYyAywd92rwhHhlULlmvPWd111HclIULU9SqZ4agxxncGZtw6e2TnyrWoNGJueJfvaH5fNe1AEUTSlxwvK6z_lSaG4AO6elSZZcwVN5_z_GK5f9GbYZWX98FSOF8GuENEjrNIi-rqewypjL2c50sP3_C6v3rzWQnZeXsW31fgBWLAeWZWuJTLN0s0dJ5qPgh_FJliOSsh8w5i9RXV-6kBIjI4EOxtOvLP47aYE1GhfOvxS4ckLRSt_qxWTxU4D8gTX55bKtdogVsY85YNRVjOWb1XPLXo1-28zu_1LePcA2zEaUuqqntLjWTlSpr6Z-wLGNgRAg_T9hl3DPo2Rt04piFBRqjrdIpuwE-YH4n9Z7mlUXuAcPiq6n8RyQzWRG_c-6K1wE9RTRoEtR4qOPvVOCp58VLuf9ZyZ3fc12wznVHAaMFUA5k6_hWeGX-Lo_Fa5qY0yAgq6xhHE3qmu9iNue_6L3rSRz2JDy8FJjGddpCtZAZESd-tbSTG4-IlytOnvM1CViy2ygKKcbWecEfllglOtxIWzclw3EZ8wXQFBFSmmhnnoMVXv5ksBL6JpLrVF3rOyGKZWISqxoMn_KdCKyBVHDjkCKsEDSyHsUfvdlJIdsYzown--og4tGE0XLrE4pNXLyIVp45JOS0yUaykHqkRPQDs9g-iioTlotza8AE5gBtWK_SF_-ULnujQu1fKBH8CyAYkUVSHJ0wWxk8kIYcpT6AagBiYU9-jqARQkc5x9PghJFx6rTa61P615QnzFKlWCDYKYxkNmwMFutN-ucVMK2MwUCjp_gt5h6xBiTT3eOg1S0F7KupXENgRSYm7E0s4GYje4Eizvlcfe-0eLS8yENjj4sYl2DORd_mAlF-5DX37Dssx_oov83DQQe6W_8GjOw5ieJpA-klmSxjRGZ5vrMc4U3EY8D-cejqv61EFJo8BPbbZMzgj6no9VNG1TSQ2vuaj0VA5vDl03Hx_MKtsHsGR47umJQDLT2Zk6jOmcSN65erXXx4SqDnrqJn9xL8iky-Z9ZWHL_Jdl9eTPERAcH0OmmHzq8ltKodC4bSz63jP2XGVBtdrPJBvwYVJVrbXoLsVsNNRQx1TSSPO_HA8XpPrbumKkuRJiUhBaCrX7j-6PK_b3e_nP2PMpzIXBD=w1595-h1272',
  ogType: 'website',
  date: '2024-01-31',
  tag1: '#IndoorGPS',
  tag2: '#Hethongdinhvitrongnha',
  tag3: '#RTLS',
  tag4: '#UWB',
  text: [
    {
      head: 'Hệ thống định vị trong nhà GPS là gì?',
      subHead: '',
      desc: 'Hệ thống định vị trong nhà GPS trong nhà là hệ thống đo lường vị trí của các đối tượng di chuyển trong không gian nội thất. Nó cho phép xác định vị trí của con người hoặc vật thể theo thời gian thực. GPS chủ yếu được sử dụng ngoài trời, tận dụng tín hiệu vệ tinh để xác định vị trí chính xác. Tuy nhiên, bên trong các tòa nhà, tín hiệu GPS thường yếu hoặc bị chặn, gây khó khăn cho việc xác định vị trí chính xác.',
      dot: '',
    },
    {
      head: 'Công nghệ hệ thống định vị trong nhà GPS',
      subHead: '',
      desc: 'Công nghệ GPS trong nhà sử dụng nhiều kỹ thuật khác nhau để khắc phục những hạn chế này. Một trong những công nghệ chính là UWB (Ultra-Wideband). UWB là công nghệ truyền thông không dây sử dụng băng thông rất rộng, cho phép đo lường vị trí chính xác và có thể cung cấp dữ liệu vị trí chính xác bên trong các tòa nhà. Bằng cách sử dụng thẻ UWB và bộ thu, có thể theo dõi vị trí của vật thể hoặc con người trong nhà. Ngoài ra, có thể sử dụng Camera AI (Trí tuệ nhân tạo) để nhận diện vật thể trong môi trường trong nhà và thực hiện theo dõi vị trí dựa trên đó. Camera AI có thể phân tích hình ảnh hoặc video để nhận diện vật thể và giúp xác định vị trí của chúng.',
      dot: '',
    },
    {
      head: 'UWB',
      subHead: '',
      desc: 'Công nghệ UWB (Ultra-Wideband) được sử dụng như một trong những công nghệ chính để triển khai GPS trong nhà. UWB là công nghệ truyền thông không dây băng thông rất rộng, được sử dụng để đo lường và theo dõi vị trí chính xác. Dưới đây là các đặc điểm chính của công nghệ UWB và cách triển khai cho GPS trong nhà:',
      dot: '',
    },
    {
      head: '',
      subHead: 'Băng thông rất rộng (Ultra-Wideband)',
      desc: 'Công nghệ UWB sử dụng băng thông rất rộng để tạo ra nhiều tín hiệu trong thời gian rất ngắn. Băng thông này cho phép đo lường thời gian và khoảng cách chính xác.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Thẻ và Bộ thu',
      desc: "Hệ thống GPS trong nhà sử dụng công nghệ UWB chủ yếu bao gồm 'thẻ' và 'bộ thu'. Thẻ được gắn vào vật thể, con người hoặc động vật và phát ra tín hiệu UWB. Bộ thu nhận tín hiệu này và xử lý để tính toán vị trí.",
      dot: '',
    },
    {
      head: '',
      subHead: 'Đo lường Thời gian bay (Time-of-Flight, ToF)',
      desc: 'Hệ thống UWB đo chính xác thời gian tín hiệu phát ra từ thẻ đến bộ thu. Thông qua đó, nó tính toán khoảng cách giữa hai thiết bị trong không gian nội thất. Nếu sử dụng nhiều bộ thu, có thể tính toán vị trí 3 chiều của đối tượng trong nhà.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Theo dõi vị trí theo thời gian thực',
      desc: 'Hệ thống sử dụng UWB hỗ trợ theo dõi vị trí nhanh chóng và chính xác, có thể cung cấp dữ liệu vị trí theo thời gian thực. Điều này rất hữu ích để theo dõi vị trí của vật thể hoặc con người trong môi trường trong nhà theo thời gian thực.',
      dot: '',
    },
    {
      head: 'Camera AI',
      subHead: '',
      desc: 'Camera AI là hệ thống camera sử dụng công nghệ Trí tuệ nhân tạo để phân tích dữ liệu hình ảnh và thực hiện các tác vụ khác nhau dựa trên đó. Cách thức hoạt động của Camera AI như sau:\n',
      dot: '',
    },
    {
      head: '',
      subHead: 'Thu thập hình ảnh',
      desc: 'Camera AI thu thập video hoặc hình ảnh từ môi trường. Để làm điều này, nó sử dụng ống kính, cảm biến hình ảnh và các thành phần phần cứng khác. Hình ảnh thu thập từ môi trường được chuyển đổi thành hình ảnh kỹ thuật số.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tiền xử lý dữ liệu',
      desc: 'Dữ liệu hình ảnh thu thập được sẽ trải qua quá trình tiền xử lý để tối ưu hóa. Ở bước này, các xử lý như điều chỉnh độ phân giải, loại bỏ nhiễu, hiệu chỉnh màu sắc của hình ảnh được thực hiện.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Trích xuất đặc trưng',
      desc: 'Camera AI trích xuất các đặc trưng quan trọng từ dữ liệu hình ảnh. Các đặc trưng này bao gồm thông tin liên quan đến vật thể, khuôn mặt, chuyển động, v.v. Việc trích xuất đặc trưng chủ yếu được thực hiện bằng cách sử dụng các thuật toán thị giác máy tính.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Áp dụng mô hình Deep Learning',
      desc: 'Camera AI sử dụng công nghệ Deep Learning để đưa các đặc trưng đã trích xuất vào mô hình mạng nơ-ron sâu. Mô hình này, trong trạng thái đã được huấn luyện, có vai trò phân tích và đưa ra phán đoán về dữ liệu đầu vào. Mô hình Deep Learning có thể thực hiện nhận diện, phân loại, theo dõi và dự đoán theo thời gian thực.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phân tích và phán đoán',
      desc: 'Camera AI thực hiện phân tích và phán đoán bằng cách sử dụng mô hình Deep Learning. Ví dụ, hệ thống nhận diện khuôn mặt có thể nhận diện khuôn mặt và trích xuất các đặc trưng khuôn mặt để xác định danh tính của khuôn mặt đó. Ngoài ra, hệ thống theo dõi vật thể có thể phát hiện và theo dõi vị trí của vật thể theo thời gian thực.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Xuất kết quả',
      desc: 'Camera AI cung cấp kết quả phân tích và phán đoán dưới định dạng đầu ra. Kết quả này có thể được hiển thị dưới nhiều hình thức khác nhau và chủ yếu truyền thông tin đến người dùng hoặc hệ thống được kết nối.',
      dot: '',
    },
    {
      head: 'Sự khác biệt so với GPS thông thường',
      subHead: '',
      desc: 'Có một số điểm khác biệt quan trọng giữa GPS trong nhà và GPS thông thường (GPS ngoài trời). Những điểm khác biệt này khiến hệ thống GPS được tối ưu hóa chủ yếu để hoạt động trong môi trường ngoài trời, gây khó khăn cho việc theo dõi vị trí chính xác trong nhà. Dưới đây là những điểm khác biệt chính giữa GPS trong nhà và GPS thông thường:',
      dot: '',
    },
    {
      head: 'Cường độ tín hiệu và Chướng ngại vật',
      subHead: 'GPS ngoài trời',
      desc: 'GPS thông thường sử dụng tín hiệu vệ tinh để xác định vị trí. Tín hiệu có thể truyền tự do trong khí quyển, do đó cường độ tín hiệu thường cao và ít bị chặn bởi các tòa nhà và vật cản.\n',
      dot: '',
    },
    {
      head: '',
      subHead: 'GPS trong nhà',
      desc: 'nhà và vật cản.\nGPS trong nhà: Bên trong các tòa nhà, tín hiệu GPS có khả năng bị suy yếu hoặc bị chặn đáng kể. Tường, trần nhà, sàn nhà, cấu trúc kim loại, v.v., có thể làm mờ hoặc chặn tín hiệu GPS.',
      dot: '',
    },
    {
      head: 'Tiếp nhận tín hiệu vệ tinh',
      subHead: 'GPS ngoài trời',
      desc: 'GPS thông thường nhận ít nhất 3 tín hiệu vệ tinh trở lên để xác định vị trí chính xác. Nhìn chung, việc sử dụng 4 vệ tinh trở lên sẽ cung cấp thông tin vị trí chính xác hơn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'GPS trong nhà',
      desc: 'Bên trong các tòa nhà, thường nhận được ít hoặc không nhận được tín hiệu vệ tinh nào. Điều này gây khó khăn cho việc theo dõi vị trí chính xác.',
      dot: '',
    },
    {
      head: 'Công nghệ hiệu chỉnh và bổ trợ',
      subHead: '',
      desc: 'Để theo dõi vị trí trong nhà, các công nghệ khác như UWB (Ultra-Wideband), RFID (Radio-Frequency Identification), Wi-Fi, Bluetooth, hệ thống theo dõi vị trí dựa trên mặt đất, v.v., được sử dụng. Việc kết hợp các công nghệ này giúp triển khai hệ thống GPS trong nhà và nâng cao độ chính xác.',
      dot: '',
    },
    {
      head: 'Độ chính xác và độ tinh vi',
      subHead: 'GPS ngoài trời',
      desc: 'GPS thông thường có thể đạt độ chính xác cao, khoảng 1 mét hoặc ít hơn trong điều kiện tốt.',
      dot: '',
    },
    {
      head: '',
      subHead: 'GPS trong nhà',
      desc: 'Hệ thống GPS trong nhà yêu cầu nỗ lực nhiều hơn để đo vị trí chính xác, và độ chính xác có thể khác nhau tùy thuộc vào môi trường, công nghệ được sử dụng và cách triển khai. Nhìn chung, nó có độ tinh vi thấp hơn.',
      dot: '',
    },
    {
      head: 'Các trường hợp ứng dụng, sử dụng hệ thống định vị GPS trong nhà',
      subHead: '',
      desc: 'Công nghệ GPS trong nhà được ứng dụng trong nhiều lĩnh vực khác nhau như điều hướng trong nhà. Thông qua đó, người dùng có thể nhận được thông tin vị trí chính xác ngay cả bên trong các tòa nhà, đồng thời nâng cao sự tiện lợi và hiệu quả của các dịch vụ và ứng dụng liên quan.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Theo dõi vị trí sản phẩm trong trung tâm mua sắm',
      desc: 'Khi người tiêu dùng ghé thăm trung tâm mua sắm, họ có thể sử dụng GPS trong nhà thông qua ứng dụng smartphone để tìm kiếm vị trí sản phẩm mong muốn theo thời gian thực. Điều này giúp người tiêu dùng nhanh chóng tìm thấy sản phẩm và cửa hàng có thể nâng cao trải nghiệm mua sắm của khách hàng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Theo dõi vị trí bệnh nhân trong bệnh viện',
      desc: 'Bệnh viện có thể sử dụng để xác định vị trí bệnh nhân theo thời gian thực, đảm bảo an toàn cho đội ngũ y tế và bệnh nhân. Ví dụ, đội ngũ y tế có thể xác định bệnh nhân đang ở đâu và phản ứng nhanh chóng trong các tình huống khẩn cấp.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hướng dẫn hành khách trong sân bay',
      desc: 'Tại các sân bay lớn, GPS trong nhà được sử dụng để giúp hành khách dễ dàng tìm thấy cổng lên máy bay, nhà hàng, cửa hàng, v.v. Thông qua ứng dụng smartphone, hành khách có thể xác định vị trí của mình trong sân bay và nhận được thông tin cần thiết.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tự động hóa và điều khiển robot trong nhà máy',
      desc: 'Sử dụng GPS trong nhà, có thể theo dõi chính xác vị trí của robot và thiết bị tự động hóa. Điều này giúp tối ưu hóa quy trình sản xuất và nâng cao hiệu quả công việc.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Điều hướng trong nhà',
      desc: 'Điều hướng trong nhà được ứng dụng hữu ích trong các tòa nhà như bảo tàng, trường đại học, khu phức hợp. Nó giúp du khách dễ dàng tìm thấy điểm đến bên trong tòa nhà và hỗ trợ khi khám phá các địa điểm du lịch hoặc cơ sở giáo dục.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý đỗ xe ô tô',
      desc: 'GPS trong nhà được sử dụng để xác định các chỗ đỗ xe trống trong bãi đỗ xe và hướng dẫn người lái xe đến chỗ đỗ. Điều này giúp rút ngắn thời gian đỗ xe và nâng cao hiệu quả của bãi đỗ xe.',
      dot: '',
    },
    {
      head: 'Tổng hợp',
      subHead: '',
      desc: 'GPS trong nhà là công nghệ theo dõi vị trí chính xác trong môi trường trong nhà, được ứng dụng trong nhiều lĩnh vực khác nhau bằng cách sử dụng các công nghệ như UWB và Camera AI. Công nghệ này mang lại hiệu quả và tiện lợi trong nhiều trường hợp sử dụng như theo dõi vị trí sản phẩm trong trung tâm mua sắm, xác định vị trí bệnh nhân trong bệnh viện, hướng dẫn hành khách tại sân bay, tự động hóa nhà máy và điều khiển robot, điều hướng trong nhà, quản lý đỗ xe ô tô. Tuy nhiên, giữa GPS trong nhà và GPS thông thường có sự khác biệt về cường độ tín hiệu và sự cản trở, khả năng tiếp nhận tín hiệu vệ tinh, độ chính xác và công nghệ hiệu chỉnh. GPS trong nhà chủ yếu chuyên biệt cho việc theo dõi vị trí trong môi trường trong nhà.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: retailExhibition.thumb,
        data: 'retailExhibition',
        link: '/vi/enterprise/retail/exhibition',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
      {
        img: constructionEquipment.thumb,
        data: 'constructionEquipment',
        link: '/vi/enterprise/construction/equipment',
      },
    ],
  },
};
